import { logger } from '../../lib/logger';
import * as components from '../../pages';

import styles from './styles.module.scss';

const StaticPage = ({ pageComponent, theme }) => {
  // eslint-disable-next-line import/namespace
  const Page = components[pageComponent];

  if (!Page) {
    const error = new Error('Missing component for fixed route.');
    logger.error(error, { page: pageComponent });
    throw error;
  }

  return (
    <main role="main" className={styles.main}>
      <Page theme={theme} />
    </main>
  );
};

export default StaticPage;
